export default __webpack_public_path__ + "static/media/icons_analyze.72e16689.svg";